export class TailoringGrades {
  static FUSED = {
    key: 'F',
    type: 'construction',
    name: 'Fused',
    bitmask: 1,
  } as const
  static HALF_CANVAS = {
    key: 'HC',
    type: 'construction',
    name: 'Half Canvas',
    bitmask: 2,
  } as const
  static FULL_CANVAS = {
    key: 'FC',
    type: 'construction',
    name: 'Full Canvas',
    bitmask: 4,
  } as const
  static HAND_FINISHED = {
    key: 'HF',
    type: 'construction',
    name: 'Hand Finished',
    bitmask: 8,
  } as const
  static HAND_SEWN = {
    key: 'HS',
    type: 'construction',
    name: 'Hand Sewn',
    bitmask: 16,
  } as const
  static UNCONSTRUCTED = {
    key: 'U',
    type: 'construction',
    name: 'Unconstructed',
    bitmask: 32,
  } as const
  static CASUAL = {
    key: 'CA',
    type: 'construction',
    name: 'Casual',
    bitmask: 2048,
  } as const
  static WOMENS = {
    key: 'W',
    type: 'construction',
    name: 'Womens',
    bitmask: 4096,
  } as const
  static RED_COLLAR = {
    key: 'RC',
    type: 'factory',
    name: 'Red Collar',
    bitmask: 64,
  } as const
  static ID_SHIRTS = {
    key: 'TAG',
    type: 'factory',
    name: 'iD Shirts',
    bitmask: 128,
  } as const
  static ID_CLOTHING = {
    key: 'BIG',
    type: 'factory',
    name: 'Fused',
    bitmask: 256,
  } as const
  static TRISCO = {
    key: 'TMTO',
    type: 'factory',
    name: 'T2iD MTO',
    bitmask: 512,
  } as const
  static TRISCO_MTM = {
    key: 'TMTM',
    type: 'factory',
    name: 'T2iD MTM',
    bitmask: 1024,
  } as const

  static ALL_CONSTRUCTION_TAILORING_GRADES = [
    this.FUSED,
    this.HALF_CANVAS,
    this.FULL_CANVAS,
    this.HAND_FINISHED,
    this.HAND_SEWN,
    this.UNCONSTRUCTED,
    this.CASUAL,
    this.WOMENS,
  ]

  static ALL_FACTORY_TAILORING_GRADES = [
    this.RED_COLLAR,
    this.ID_CLOTHING,
    this.ID_SHIRTS,
    this.TRISCO,
    this.TRISCO_MTM,
  ]
}
